/* eslint-disable */

import React from 'react';

const UIButtonSmallRounded = ({
  text,
  handleClick,
}: {
  text: string,
  handleClick: () => void;
}) => {
  return (
    <button
      className={`bg-main-blue text-white text-sm py-2.5 px-8 font-semibold ` +
      `shadow-md rounded-lg mr-4 hover:brightness-110 hover:shadow-lg active:scale-[0.97] transition-all duration-150`}
      onClick={() => handleClick()}
    >
      {text}
    </button>
  );
};

export default UIButtonSmallRounded;
